import {createSelector, type Selector} from 'reselect';

import {useMemoizedSelector} from '../../state/hooks';
import type * as PanelTypes from '../../state/views/panel/types';
import {type RootState} from '../../types/redux';
import {type MarimoConfig} from './common';

const selectPanel = (panelRef: PanelTypes.Ref) => (state: RootState) =>
  state.views.parts[panelRef.type][panelRef.id];

function makeNotebookIDSelector(
  panelRef: PanelTypes.Ref
): Selector<RootState, string | undefined> {
  return createSelector(
    selectPanel(panelRef),
    panel => (panel.config as MarimoConfig).notebookId
  );
}

export function usePanelNotebookID(
  panelRef: PanelTypes.Ref
): string | undefined {
  return useMemoizedSelector(makeNotebookIDSelector, panelRef);
}
